import { useMemo, useState } from 'react'
import { Card, Tree, Input, Typography } from 'antd'
import { FolderOutlined } from '@ant-design/icons'
import type { DataNode } from 'antd/es/tree'

import productCenter from '../data/productCenter.json'

const buildTree = (nodes: any[], parentPath = ''): DataNode[] =>
  (nodes || []).map((node) => {
    const path = parentPath ? `${parentPath} / ${node.name}` : node.name
    return {
      key: node.fullCid || String(node.id),
      title: node.name,
      icon: <FolderOutlined />,
      children: buildTree(node.childVo || [], path),
    }
  })

const CategoryTree = () => {
  const [keyword, setKeyword] = useState('')
  const treeData = useMemo(() => buildTree(productCenter.categoryTree), [])
  return (
    <Card title="商品中心 · 类目树">
      <Input allowClear placeholder="搜索类目后展开父节点查看" value={keyword} onChange={e => setKeyword(e.target.value)} style={{ maxWidth: 360, marginBottom: 16 }} />
      <Tree.DirectoryTree
        defaultExpandParent
        treeData={treeData}
        height={560}
        virtual={false}
        showLine
      />
    </Card>
  )
}

export default CategoryTree


